import { BodyContentTypesEnum } from '../enums/BodyContentTypes.enum';

export class BodyContentsModel {
    bodyContentType: BodyContentTypesEnum;
    bodyContent: string;
    orderId: number;

    constructor(bodyContentType, bodyContent, orderId?) {
        this.bodyContentType = bodyContentType;
        this.bodyContent = bodyContent;
        this.orderId = orderId || 0;
    }
}
